/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgCloudCrossBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M21 11.4C21 11.4 20.7453 10.3804 19.3316 9.8433C19.4407 9.53241 19.5 9.19812 19.5 8.84998C19.5 7.19312 18.1569 5.84998 16.5 5.84998C16.1767 5.84998 15.8654 5.90111 15.5737 5.99572C14.9765 3.75258 12.9312 2.09998 10.5 2.09998C7.6005 2.09998 5.25 4.45048 5.25 7.34998C5.25 7.6832 5.28105 8.00918 5.3404 8.32517C3.54555 8.91667 2.25 10.607 2.25 12.6C2.25 15.0853 4.26472 17.1 6.75 17.1H10.8M15.6 22.8L19.2 19.2M19.2 19.2L22.8 15.6M19.2 19.2L15.6 15.6M19.2 19.2L22.8 22.8"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgCloudCross = wrapIcon(SvgCloudCrossBase);
export default SvgCloudCross;
